import React, { useMemo } from "react";

import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
  OrgIdNameDto,
} from "@intelligems/ig-types";
import { AssignedOrgsContent } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/AssignedOrgsContent";
import { UnassignedOrgsContent } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/SubscriptionsTab/AgencySubscriptionPanel/AgencyProductAccordion/UnassignedOrgsContent";

interface TableSectionProps {
  item: AgencySubscriptionItemDto;
  agency: FullAgencyDto;
  subscription: AgencySubscriptionDto;
}

export const TableSection = ({
  item,
  agency,
  subscription,
}: TableSectionProps) => {
  const unassignedOrgs: OrgIdNameDto[] = useMemo(() => {
    return agency.organizationAgencyLinks
      .filter((oa) =>
        subscription.items.every(
          (item) =>
            !item.stripeProductLinks.some(
              // eslint-disable-next-line max-nested-callbacks
              (spl) => spl.organization.id === oa.organization.id
            )
        )
      )
      .map((org) => org.organization);
  }, [agency.organizationAgencyLinks, agency.subscriptions]);

  return (
    <>
      <AssignedOrgsContent
        item={item}
        agency={agency}
        subscription={subscription}
      />
      <UnassignedOrgsContent
        unassignedOrgs={unassignedOrgs}
        agency={agency}
        item={item}
        subscription={subscription}
      />
    </>
  );
};
